import cn from 'classnames'
import { FC } from 'react'
import cards, { ICard, IProgressBar } from 'static/progress'

import { useTranslation } from 'next-i18next'

import Section from 'components/Section/Section'

import styles from './OurProgress.module.scss'

const ProgressBar: FC<IProgressBar> = ({
  icon,
  percentage,
  title,
  subtitle,
  color,
  description,
}) => {
  const { t } = useTranslation(['stats'])
  return (
    <div className={styles.ProgressBar}>
      <div className={styles.Description}>{t(`stats:ourProgress${description}`)}</div>
      <div className={styles.Content}>
        <div style={{ backgroundColor: color }} className={styles.Icon}>
          <img src={icon} alt="progress" />
        </div>
        <div
          style={{
            background: `linear-gradient(90deg, transparent 0%, ${color} ${percentage}%, transparent ${percentage}%, transparent 100%)`,
          }}
          className={styles.Progress}
        />
        <div className={styles.Title}>{title}</div>
        <div className={styles.Subtitle}>{t(`stats:ourProgress${subtitle}`)}</div>
      </div>
    </div>
  )
}

type CardProps = ICard & {
  className?: string
}
const Card: FC<CardProps> = ({ className, year, bars }) => {
  const { t } = useTranslation(['stats'])
  return (
    <div className={cn(styles.cardWrapper, className)}>
      <div className={styles.missionCard}>
        {bars.map((card, idx) => {
          return <ProgressBar key={idx} {...card} />
        })}
      </div>
      <div className={styles.cardDescription}>
        <span>
          {year}
          &nbsp;
        </span>
        <span>{t('stats:ourStoryYear')}</span>
      </div>
    </div>
  )
}

const Mission = () => {
  const { t } = useTranslation(['stats'])
  return (
    <Section backgroundClass={styles.background}>
      <div className={styles.grid}>
        <h2 className={styles.title}>{t('stats:ourProgressTitle')}</h2>
        <div className={styles.cards}>
          {cards.map((card, idx) => {
            return <Card key={idx} {...card} />
          })}
        </div>
      </div>
    </Section>
  )
}

export default Mission
